import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getI18nLanguage } from 'i18n';
import { Alert } from 'library/components/alerts';
import Loader from 'library/components/loaders/Loader';
import {
	hideAlert,
	selectAlertsAndNotifications,
	selectUser,
} from 'library/redux/application';
import { useAppDispatch, useAppSelector } from 'library/redux/hooks';

const Global = () => {
	const { i18n } = useTranslation();
	const { language } = useAppSelector(selectUser);
	const {
		loader: { isVisible: loaderIsVisible, message: loaderMessage },
		alert: {
			customHeader,
			isVisible: alertIsVisible,
			message: alertMessage,
			shouldBeCloseManually,
			type,
			visibilityTime,
		},
	} = useAppSelector(selectAlertsAndNotifications);
	const dispatch = useAppDispatch();

	useEffect(() => {
		i18n.changeLanguage(getI18nLanguage(language));
		document.documentElement.lang = language;
	}, [i18n, language]);

	useEffect(() => {
		if (alertIsVisible && !shouldBeCloseManually) {
			setTimeout(() => {
				dispatch(hideAlert());
			}, visibilityTime);
		}
	}, [dispatch, alertIsVisible, shouldBeCloseManually, visibilityTime]);

	const shouldRenderScreen = useMemo(
		() => alertIsVisible || loaderIsVisible,
		[alertIsVisible, loaderIsVisible]
	);

	return shouldRenderScreen ? (
		<div className="screen">
			<div className="screen__background">
				{loaderIsVisible && (
					<Loader translatedText={loaderMessage ?? ''} />
				)}
				{alertIsVisible && (
					<Alert
						message={alertMessage}
						type={type}
						customHeader={customHeader}
						onCloseClick={hideAlert}
					/>
				)}
			</div>
		</div>
	) : null;
};

export default Global;
